import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatIconModule } from "@angular/material/icon";
import { MatRadioModule } from "@angular/material/radio";
import { TranslateModule } from "@ngx-translate/core";
import { ItemSelectorComponent } from "./item-selector.component";

@NgModule({
  declarations: [ItemSelectorComponent],
  imports: [CommonModule, MatIconModule, MatCheckboxModule, MatRadioModule, MatIconModule, TranslateModule, FormsModule, MatButtonModule],
  exports: [ItemSelectorComponent],
})
export class ItemSelectorModule {}
